import React from 'react';
import PropTypes from 'prop-types';
import useLocale from '@/hooks/useLocale';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

const ProPlanVariant = ({
  testId,
  hideButtons,
  hideActivateTrial,
  isAAClient,
  onActivateProtectionPro,
  onActivateTrial,
  enableTrial,
}) => {
  const { gatorProtect } = useLocale();

  if (!gatorProtect?.summary?.protectionCard?.automaticProtectionAvailable) {
    return null;
  }

  const {
    title,
    description,
    activateProtectionPro,
    activateTrial,
  } = gatorProtect.summary.protectionCard.automaticProtectionAvailable;

  const activateTrialByClientType = isAAClient ? activateTrial?.aa : activateTrial?.regular;

  const showTrialButton = enableTrial && !hideActivateTrial && Boolean(activateTrialByClientType);
  const showActions = !hideButtons && Boolean(activateProtectionPro);

  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{title}</ProtectionCardTitle>
          <ProtectionCardDescription html={description} />
          {showActions && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={activateProtectionPro.variant}
                hasMultipleButtons={showTrialButton}
                onClick={onActivateProtectionPro}
                testId={`${testId}__action-${activateProtectionPro.key}`}
              >
                {activateProtectionPro.label}
              </ProtectionCardButton>
              {showTrialButton && (
                <ProtectionCardButton
                  variant={activateTrialByClientType.variant}
                  hasMultipleButtons
                  onClick={onActivateTrial}
                  testId={`${testId}__action-${activateTrialByClientType.key}`}
                >
                  {activateTrialByClientType.label}
                </ProtectionCardButton>
              )}
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={title} />
    </ProtectionCardRoot>
  );
};

ProPlanVariant.propTypes = {
  testId: PropTypes.string,
  hideButtons: PropTypes.bool,
  hideActivateTrial: PropTypes.bool,
  isAAClient: PropTypes.bool,
  onActivateProtectionPro: PropTypes.func,
  onActivateTrial: PropTypes.func,
  enableTrial: PropTypes.bool,
};

ProPlanVariant.defaultProps = {
  testId: 'pro-plan-variant',
  hideButtons: false,
  hideActivateTrial: false,
  isAAClient: false,
  onActivateProtectionPro: undefined,
  onActivateTrial: undefined,
  enableTrial: PropTypes.bool,
};

export default ProPlanVariant;
